/* eslint-disable no-undef */
import { Helmet } from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Check from '@zg-rentals/multibrand-ui/lib/icons/Check';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

import queryUtil from '../../../utils/queryUtils';
import sharedConfig from '../../../sharedConfig';

const feedbackSuccessCategories = {
  NONE: -1,
  ONE_POSITIVE: 0,
  ONE_NEGATIVE: 1,
  MULTIPLE: 2,
};

// query params assumed: inquiryFeedbackType, hash, inquiryId, aliasEncoded
class InquiryFeedbackSuccessPage extends React.Component {
  constructor(props) {
    super(props);

    this.getTitle = this.getTitle.bind(this);
    this.getDescription = this.getDescription.bind(this);
  }

  getTitle() {
    const { query } = this.props;
    switch (parseInt(query.category)) {
      case feedbackSuccessCategories.ONE_POSITIVE:
        return 'Great! Thank you for your feedback.';
      case feedbackSuccessCategories.ONE_NEGATIVE:
        return "Sorry to hear. We'll look into it.";
      case feedbackSuccessCategories.MULTIPLE:
        return 'Thank you for your feedback.';
      default:
        return '';
    }
  }

  getDescription() {
    const { query } = this.props;

    switch (parseInt(query.category)) {
      case feedbackSuccessCategories.ONE_POSITIVE:
        return 'Ready to search for more properties?';
      case feedbackSuccessCategories.ONE_NEGATIVE:
        return "Don't give up! We encourage you to keep looking.";
      case feedbackSuccessCategories.MULTIPLE:
        return "We'll use it to improve your experience.";
      default:
        return '';
    }
  }

  handleCheckPropertyNotAvailable(checked) {
    this.setState({
      showNoLongerAvailableNotif: checked,
    });
    if (checked) {
      setTimeout(() => {
        this.setState({
          showNoLongerAvailableNotif: false,
        });
      }, 3000);
    }
  }

  render() {
    const { brand } = this.props;
    const title = this.getTitle();
    const description = this.getDescription();
    let homeLink = '/';
    if (brand === sharedConfig.brands.zillow) {
      homeLink = '/renting';
    }

    return (
      <div className="InquiryFeedbackSuccessPage">
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>Thank You!</title>
        </Helmet>
        <Container>
          <Section>
            <Center>
              <div className="stacked-md">
                {brand === 'hotpads' ? (
                  <Check colorType="success" size="24" />
                ) : (
                  <Check colorType="success" size="42" />
                )}
              </div>
              <div className="stacked-lg">
                <Text type="h3">{title}</Text>
              </div>

              <Row>
                <Text type="body">{description}</Text>
              </Row>
              <Row>
                <Col xs={0} sm={3} md={4} />
                <Col xs={12} sm={6} md={4}>
                  <Center>
                    <Link href={homeLink}>Search for more homes</Link>
                  </Center>
                </Col>
                <Col xs={0} sm={3} md={4} />
              </Row>
            </Center>
          </Section>
        </Container>
      </div>
    );
  }
}

InquiryFeedbackSuccessPage.propTypes = {
  query: PropTypes.object,
  brand: PropTypes.string,
};

const mapStateToProps = (state) => ({
  query: queryUtil.parse(state.router.location.search),
  brand: state.app.brand,
  currentArea: state.area.currentArea,
});

export default connect(mapStateToProps)(InquiryFeedbackSuccessPage);
